{
  "Ahriman": [
    "Wing Attack",
    "Look of Devil",
    "Look of Fright",
    "Doom*"
  ],
  "Apanda": [
    "Bio Tenebris",
    "Bio Venenum",
    "Bio Oleum",
    "Bio Ranae",
    "Bio Tardus",
    "Bio Silentium",
    "Bio Lapis",
    "Bio Immortuos",
    "Bio Mortem",
    "Bio Insanis"
  ],
  "Archaic Demon": [
    "Lifebreak",
    "Dark Holy",
    "Giga Flare",
    "Empower",
    "Despair",
    "Despair 2"
  ],
  "Behemoth": [
    "Stab Up",
    "Frozen Cry",
    "Giga Flare*"
  ],
  "Black Chocobo": [
    "Choco Attack",
    "Choco Ball",
    "Choco Esuna",
    "Choco Meteor*"
  ],
  "Black Goblin": [
    "Tackle",
    "Turn Punch",
    "Goblin Punch",
    "Mutilate*"
  ],
  "Blue Dragon": [
    "Slam",
    "Ice Breath",
    "Tail Swing",
    "Fire Breath*"
  ],
  "Bomb": [
    "Bite",
    "Self Destruct",
    "Flame Attack",
    "Spark*"
  ],
  "Bull Demon": [
    "Shake Off",
    "Storm Around",
    "Blow Fire*"
  ],
  "Byblos": [
    "Energize",
    "Parasite",
    "Vengeance",
    "Manaburn",
    "Chicken"
  ],
  "Chocobo": [
    "Choco Attack",
    "Choco Cure",
    "Choco Esuna",
    "Choco Ball*"
  ],
  "Cockatrice": [
    "Scratch Up",
    "Beak",
    "Feather Bomb",
    "Peck*"
  ],
  "Coeurl": [
    "Scratch",
    "Cat Kick",
    "Blaster",
    "Poison Nail*"
  ],
  "Dark Behemoth": [
    "Stab Up",
    "Frozen Cry",
    "Ulmaguest*"
  ],
  "Dragon": [
    "Slam",
    "Thunder Breath",
    "Tail Swing",
    "Ice Breath*"
  ],
  "Draugr": [
    "Knife Hand",
    "Aqua Soul",
    "Frost Soul",
    "Wind Soul*"
  ],
  "Dryad": [
    "Leaf Dance",
    "Calm Spirit",
    "Protect Spirit",
    "Spirit of Life*"
  ],
  "Explosive": [
    "Bite",
    "Self Destruct",
    "Spark",
    "Small Bomb*"
  ],
  "Floating Eye": [
    "Wing Attack",
    "Look of Fright",
    "Beam",
    "Look of Devil*"
  ],
  "Ghost": [
    "Throw Spirit",
    "Grease Touch",
    "Drain Touch",
    "Zombie Touch*"
  ],
  "Ghoul": [
    "Throw Spirit",
    "Sleep Touch",
    "Knife Hand",
    "Grease Touch*"
  ],
  "Gobbledeguck": [
    "Tackle",
    "Eye Gouge",
    "Mutilate",
    "Goblin Punch*"
  ],
  "Goblin": [
    "Tackle",
    "Eye Gouge",
    "Goblin Punch",
    "Turn Punch*"
  ],
  "Great Malboro": [
    "Tendrils",
    "Bad Breath",
    "Moldball Virus",
    "Goo*"
  ],
  "Grenade": [
    "Bite",
    "Small Bomb",
    "Self Destruct",
    "Flame Attack*"
  ],
  "Holy Dragon": [
    "Holy Breath",
    "Fire Breath",
    "Ice Breath",
    "Thunder Breath"
  ],
  "Hydra": [
    "Triple Attack",
    "Triple Flame",
    "Triple Thunder*"
  ],
  "Iron Hawk": [
    "Scratch Up",
    "Peck",
    "Shine Lover",
    "Feather Bomb*"
  ],
  "Juravis": [
    "Scratch Up",
    "Feather Bomb",
    "Shine Lover",
    "Fury*"
  ],
  "King Behemoth": [
    "Stab Up",
    "Frozen Cry",
    "Hurricane*"
  ],
  "Malboro": [
    "Tendrils",
    "Lick",
    "Noxious Gas",
    "Bad Breath*"
  ],
  "Mindflayer": [
    "Tentacle",
    "Mind Blast",
    "Odd Soundwave",
    "Level Blast*"
  ],
  "Minotaur": [
    "Shake Off",
    "Blow Fire",
    "Gather Power*"
  ],
  "Ochu": [
    "Tendrils",
    "Goo",
    "Lick",
    "Noxious Gas*"
  ],
  "Pisco Demon": [
    "Tentacle",
    "Black Ink",
    "Level Blast",
    "Odd Soundwave*"
  ],
  "Plague": [
    "Wing Attack",
    "Doom",
    "Look of Devil",
    "Beam*"
  ],
  "Porky": [
    "Straight Dash",
    "Toot",
    "Bequeath Bacon",
    "Snort*"
  ],
  "Reaper": [
    "Knife Hand",
    "Wind Soul",
    "Thunder Soul",
    "Frost Soul*"
  ],
  "Red Chocobo": [
    "Choco Attack",
    "Choco Meteor",
    "Choco Ball",
    "Choco Cure*"
  ],
  "Red Dragon": [
    "Slam",
    "Fire Breath",
    "Tail Swing",
    "Thunder Breath*"
  ],
  "Red Panther": [
    "Scratch",
    "Poison Nail",
    "Cat Kick",
    "Accumulate*"
  ],
  "Revenant": [
    "Throw Spirit",
    "Drain Touch",
    "Zombie Touch",
    "Sleep Touch*"
  ],
  "Sekhret": [
    "Shake Off",
    "Mimic Titan",
    "Gather Power",
    "Storm Around*"
  ],
  "Serpentarius": [
    "Snake Carrier",
    "Toxic Toad",
    "Midgar Swarm",
    "Scream"
  ],
  "Skeleton": [
    "Knife Hand",
    "Thunder Soul",
    "Frost Soul",
    "Aqua Soul*"
  ],
  "Squidraken": [
    "Tentacle",
    "Black Ink",
    "Odd Soundwave",
    "Mind Blast*"
  ],
  "Steel Giant": [
    "Destroy",
    "Compress",
    "Dispose",
    "Repair"
  ],
  "Swine": [
    "Straight Dash",
    "Oink",
    "Bequeath Bacon",
    "Toot*"
  ],
  "Taiju": [
    "Leaf Dance",
    "Magic Spirit",
    "Spirit of Life",
    "Magic Barrier*"
  ],
  "Tiamat": [
    "Triple Attack",
    "Triple Thunder",
    "Triple Breath",
    "Dark Whisper*"
  ],
  "Treant": [
    "Leaf Dance",
    "Spirit of Life",
    "Protect Spirit",
    "Calm Spirit*"
  ],
  "Ultima Demon": [
    "Nanoflare",
    "Dark Holy",
    "Ultima",
    "Hurricane",
    "Ulmaguest",
    "Empower"
  ],
  "Vampire": [
    "Scratch",
    "Blaster",
    "Blood Suck",
    "Cat Kick*"
  ],
  "Wild Boar": [
    "Straight Dash",
    "Snort",
    "Bequeath Bacon",
    "Oink*"
  ],
  "Wyvern": [
    "Triple Attack",
    "Noxious Gas",
    "Triple Breath*"
  ]
}
